import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { PageActions } from '../../components/ui/PageActions.tsx';
import { Link } from 'react-router';
import { useMe } from '../../lib/auth.tsx';
import { useGridQuery, useGridState } from '../../lib/grid.ts';
import { TASK_STATUS, d10, type TaskRow } from '../../lib/assessments.ts';
import { DataTable, type Column } from '../../components/DataTable.tsx';
import { Badge, LinkButton } from '../../components/ui/Button.tsx';
import { can } from '../../lib/perm.ts';
import { fmtDate } from '../../lib/date.ts';

const SOURCE: Record<string, string> = { assessment_result: '점검 결과', manual: '수동', vendor_audit: '수탁사 점검' };
const columns: Column<TaskRow>[] = [
  { key: 'title', label: '과제', filter: 'text', render: (t) => <Link className="text-accent-strong hover:underline" to={`/assessments/tasks/${t.id}`}>{t.title}</Link> },
  { key: 'sourceType', label: '출처', row: 2, span: 6, wrap: true, filter: 'select', render: (t) => <span className="text-[12px]">{SOURCE[t.sourceType] ?? t.sourceType}{t.runLabel ? ` · ${t.runLabel}` : ''}</span> },
  { key: 'ownerId', label: '담당자', width: '7rem', filter: 'select', sortable: false, render: (t) => t.ownerName || '—' },
  { key: 'deptId', label: '부서', width: '7rem', filter: 'select', sortable: false, render: (t) => t.deptName || '—' },
  { key: 'status', label: '상태', width: '6rem', filter: 'select', render: (t) => <Badge tone={TASK_STATUS[t.status]?.tone ?? 'neutral'}>{TASK_STATUS[t.status]?.label ?? t.status}</Badge> },
  { key: 'dueDate', label: '기한', width: '6.5rem', filter: 'date', render: (t) => <span className={t.overdue ? 'text-red-700 font-medium' : ''}>{d10(t.dueDate)}{t.overdue && ' 지연'}</span> },
  { key: 'closedAt', label: '완료', width: '6.5rem', filter: 'date', render: (t) => fmtDate(t.closedAt) },
];

/** 개선과제 목록 — 서버사이드 그리드 + 수동 등록 */
export function RemediationTasksPage() {
  const me = useMe();
  const { state, set } = useGridState('rt', { sort: { col: 'dueDate', dir: 'asc' } });
  const data = useGridQuery<TaskRow>('remediation-grid', '/assessments/tasks/grid', state);
  const canCreate = can(me.data, 'remediation.manage');
  return (
    <div>
      <PageHeader title="개선과제" />
      {data.isError && <div className="text-red-600 text-sm mb-2">{(data.error as Error).message}</div>}
      <DataTable id="remediation-tasks" columns={columns} data={data.data} state={state} onChange={set} isFetching={data.isFetching} />
      <PageActions>{canCreate && <LinkButton to="/assessments/tasks/new">과제 등록</LinkButton>}</PageActions>
    </div>
  );
}
